import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { Alert } from 'src/components/alert';
import { Link } from 'src/components/link';
import { config } from 'src/config/config';
import { i18n } from 'src/i18n';
import { warningImageProps } from 'src/resources/images';
import { I18nUtils } from 'src/utils/i18n-utils';

export const CustomerDebtAlert: FunctionComponent = (props) => {
  const renderContactCustomerService = () =>
    I18nUtils.richMessage(i18n.component.error.customerDebtAlert.subtitle, {
      linkToCustomerService: (
        <Link variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} target="_blank" href={config.CUSTOMER_SERVICE}>
          {i18n.component.error.customerDebtAlert.linkToCustomerService}
        </Link>
      ),
    });

  return (
    <Alert
      {...props}
      icon={warningImageProps}
      title={i18n.component.error.customerDebtAlert.title}
      text={renderContactCustomerService()}
    />
  );
};
